import script from "./download.vue?vue&type=script&setup=true&lang=js"
export * from "./download.vue?vue&type=script&setup=true&lang=js"

import "./download.vue?vue&type=style&index=0&id=3c4a2fba&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4a2fba"]])

export default __exports__